// Getters do slice `chat` (spec-003 G6). Re-exportados por store/getters.js.
//
// ★ Nomes FIXOS pelos componentes reusados do IA CRM (`messages.vue`, `send-message.vue`
// leem `this.$store.getters[storeModule + '/<nome>']`): `messages`, `chatLoading`,
// `responseTokens`, `thinkingSteps`, `toolCalls`, `pendingConfirmation`, `persona`,
// `servicosCitadosStreaming`. NÃO renomear.

import { PERSONA_AI_FRAMEWORK } from '@modules/aawz-intelligence-v2/constants/Personas'

const chat = (state) => state.chat || {}

// --- Seletor de agentes (contrato §4.2) ---
export const agents = (state) => chat(state).agents || []
export const loadingAgents = (state) => chat(state).loadingAgents
export const selectedAgentId = (state) => chat(state).selectedAgentId
export const chatModuleForbidden = (state) => chat(state).moduleForbidden
export const hasAgents = (state) => (chat(state).agents || []).length > 0
export const selectedAgent = (state) => {
  const id = chat(state).selectedAgentId
  if (id === null || id === undefined) return null
  const found = (chat(state).agents || []).find((a) => a.id === id)
  return found || null
}

// --- Conversas (consumidas pela view p/ alimentar o agent-selector-list) ---
export const conversations = (state) => chat(state).conversations || []
export const conversationsLoading = (state) => chat(state).loadingConversations
export const selectedConversationId = (state) => chat(state).selectedConversationId

// --- Thread / stream (nomes exigidos pelo `messages.vue` reusado) ---
export const messages = (state) => chat(state).messages || []
export const chatLoading = (state) => chat(state).streaming
export const responseTokens = (state) => chat(state).responseTokens || []
export const thinkingSteps = (state) => chat(state).thinkingSteps || []
export const toolCalls = (state) => chat(state).activeToolCalls || []

// ★ pendingConfirmation SEMPRE null — espelho UI do RF6.1 (nenhum caminho de commit na UI).
// Neutraliza o embed do `IaConfirmAction` dentro do `messages.vue` reusado: com null, o
// `showConfirmAction` do messages.vue é sempre false. A proposta de escrita é renderizada
// pelo `proposed-action-card` (SEM botões) — desde a spec-001 do `plataforma-por-chat`
// ([T018]) ele é montado DENTRO da thread, pelo registry de cartões
// (`ai-framework/acao-proposta`), a partir da parte de tool que o `APIAgentChat` cria.
// Testado no unit.
export const pendingConfirmation = () => null

// ★ Persona do chat de agentes. Constante, como `pendingConfirmation`: os agentes não gravam
// `context`, então não há o que ler do state. Existe porque o `messages.vue` reusado resolve a
// persona por `storeModule` — sem este getter ele cairia na default (IA Operacional), que tem
// `permiteHtml: true` e renderizaria a saída do agente como HTML.
export const persona = () => PERSONA_AI_FRAMEWORK

// Sem serviços citados neste chat (é feature do Consultor Estratégico). Constante para o
// `messages.vue` reusado não precisar de um caso especial por módulo.
export const servicosCitadosStreaming = () => []
// Idem: o `perguntar_ao_gestor` e do Consultor, nao dos agentes do framework.
export const perguntasAoGestorStreaming = () => []

// --- Propostas de escrita (awaiting_approval) + gates inline ---
//
// `pendingProposals` é a lista do que o RUN deixou pendente — alimentada pelo motor
// (`setPendingConfirmation` durante o turno, `setAcoesPendentes` no `end`, com os
// resumos canônicos NC-8). Desde o [T018] ela não desenha mais o cartão: quem o
// desenha é a thread, pelo registry. Continua aqui porque é o estado do run, e é
// dele que a fila do gestor (spec-004) parte.
export const pendingProposals = (state) => chat(state).pendingProposals || []
export const systemMessages = (state) => chat(state).systemMessages || []
export const currentRunId = (state) => chat(state).currentRunId
